//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { TramLargeSVG } from './svg'

interface TramLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const TramLargeIcon: React.FC<TramLargeIconProps> = forwardRef<
  TramLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon ref={ref} boxSize={boxSize} as={TramLargeSVG} sx={sx} />
))
